import { Component, OnInit } from "@angular/core";
import { AppMainComponent } from "../main/app.main.component";
import { AppComponent } from "../app.component";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { SubProcesosService } from "../services/sub-procesos.service";
import { BehaviorSubject, Observable } from "rxjs";

@Component({
    selector: "app-topbar",
    templateUrl: "./app.topbar.component.html",
})
export class AppTopBarComponent implements OnInit {
    notificaciones: any[] = [];

    get bedcum(): Observable<string> {
        return this.app.subjectBreadCumb.asObservable();
    }

    constructor(
        public app: AppMainComponent,
        public appComp: AppComponent,
        public auth: AuthenticationService,
        private sProcessService: SubProcesosService
    ) {}

    ngOnInit(): void {
        this.subNotifications();
        //   console.log(this.auth.currentUserValue);
    }

    subNotifications() {
        this.sProcessService.initNotification();
        this.sProcessService.subNoti().subscribe((res) => {
            this.notificaciones = res;
        });
    }

    checkNotificacions() {
        return this.notificaciones.length > 0;
    }
}
